import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

// Pass-through layout: the list and the full-page forms are child routes.
const ContactsLayout = () => <Outlet />

export const Route = createFileRoute('/_authenticated/$workspaceSlug/contacts')({
  component: ContactsLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Contacts`) }] }),
})
